export default "__VITE_ASSET__zk_NxoT9__"